import type { Rgb } from '@/lib/cloud/types'

const hex = (value: string): Rgb => {
    const n = parseInt(value.slice(1), 16)

    return [((n >> 16) & 255) / 255, ((n >> 8) & 255) / 255, (n & 255) / 255]
}

export const PALETTE = {
    point: hex('#D8D2C4'),
    ink: hex('#ECE6D8'),
    bright: hex('#F5EFE3'),
    white: hex('#FFF9EF'),
    signal: hex('#86B6F0'),
    heat: hex('#86B6F0'),
    ember: hex('#A9CCF5'),
    cool: hex('#737C80'),
    thermal: hex('#D3C9B8'),
    warmGrey: hex('#4E5257'),
    peach: hex('#C7D3DF'),
    sand: hex('#B3A998')
}

export const mixRgb = (a: Rgb, b: Rgb, t: number): Rgb => [
    a[0] + (b[0] - a[0]) * t,
    a[1] + (b[1] - a[1]) * t,
    a[2] + (b[2] - a[2]) * t
]

/**
 * Thermal ramp: cool grey (low heat loss) to cream to signal blue (high heat loss). The whole site uses
 * one accent, the cyanotype signal blue, for interface and for heat in data alike.
 */
export const thermalRamp = (heat: number): Rgb => {
    const h = Math.min(1, Math.max(0, heat))

    if (h < 0.5) return mixRgb(PALETTE.cool, PALETTE.thermal, h / 0.5)

    return mixRgb(PALETTE.thermal, PALETTE.heat, (h - 0.5) / 0.5)
}
